import { createAction } from 'redux-actions'

const ns = 'statistics/'

export const getSpecificCompanyStatistics = createAction(`${ns}GET_COMPANY_STATISTICS`)
export const getSpecificCompanyStatisticsSuccess = createAction(`${ns}GET_COMPANY_STATISTICS_SUCCESS`)
export const getSpecificCompanyStatisticsFail = createAction(`${ns}GET_COMPANY_STATISTICS_FAIL`)
export const setSelectedCompanyId = createAction(`${ns}SET_SELECTED_COMPANY_ID`)
